/**
 * Email domain typo suggestions for checkout parent account creation.
 * Uses mailcheck (distance-based). Optional extra domains below if mailcheck omits one we need.
 */
const Mailcheck = require("mailcheck");
const {isValidEmail} = require("./StringUtil");

// Optional: append domains that mailcheck omits—only when we have a concrete need.
const EXTRA_DOMAINS = [];

/**
 * @param {string} email
 * @returns {{full: string, address: string, domain: string}|null}
 */
function getEmailTypoSuggestion(email) {
	if (!email || typeof email !== "string") {
		return null;
	}
	const trimmed = email.trim();
	if (!isValidEmail(trimmed)) {
		return null;
	}

	const domains = Mailcheck.defaultDomains.concat(EXTRA_DOMAINS);

	const suggestion = Mailcheck.run({
		email: trimmed,
		domains,
		suggested: s => s,
		empty: () => null,
	});

	if (
		!suggestion ||
		!suggestion.full ||
		!suggestion.domain ||
		!isValidEmail(suggestion.full)
	) {
		return null;
	}
	if (suggestion.full.toLowerCase() === trimmed.toLowerCase()) {
		return null;
	}

	return {
		full: suggestion.full,
		address: suggestion.address,
		domain: suggestion.domain,
	};
}

module.exports = {
	getEmailTypoSuggestion,
};
